import axios from 'axios';
import { configRefs } from '@utils/constants';

async function postFavouriteRequest(productId, user, descriptor) {
  const endpoint = await configRefs.apis.userdata.get();
  const res = await axios.post(`${endpoint}/api/FavoritesV2`, {
    userID: user.id,
    userInstitutionID: user.institution?.id,
    productID: productId,
    dynamicContent: descriptor
  });
  return {
    ...descriptor,
    createdAt: new Date(),
    id: res.data.objectID
  };
}
async function deleteFavouriteRequest(descriptor) {
  const endpoint = await configRefs.apis.userdata.get();
  if (!descriptor.id) {
    throw new Error("deleteFavouriteRequest(): Descriptor not yet synced with backend", {
      cause: descriptor
    });
  }
  await axios.delete(`${endpoint}/api/FavoritesV2/${descriptor.id}`);
}

export { deleteFavouriteRequest, postFavouriteRequest };
//# sourceMappingURL=toggle-favourite.request.js.map
